import { selectByMode } from "./mode";

const config = {
  localhost: { url: "http://localhost:8010" },
  dev: { url: "https://dev.connect.lesateliersoo.fr" },
  production: { url: "https://connect.lesateliersoo.fr" },
  test: { url: "test.com" },
  demo: { url: "http://localhost:8010" },
};

export default selectByMode(config);
